import {
    FETCH_USERS, FETCH_USERS_SUCCESS, FETCH_USERS_FAILURE,
    SEND_USERS_CSV_START, SEND_USERS_CSV_SUCCESS, SEND_USERS_CSV_FAILURE,
    SEND_PASSWORD_RESET_START, SEND_PASSWORD_RESET_SUCCESS, SEND_PASSWORD_RESET_FAILURE,
    EMPTY_USERS, SET_USERS, SET_SORTED_USERS
} from './constants';

const initialState = {
    users: [],
    usersMetadata: {page: 0},
    sortedUsers: [],
    isFetching: false,
    isSendingUsersCsv: false,
    isSendingPasswordReset: false,
    error: {},
    sendUsersCsvError: {}
};

function usersReducer(state = initialState, action) {
    switch(action.type) {
        case EMPTY_USERS:
            return initialState;
        case FETCH_USERS:
            return Object.assign({}, state, {
                isFetching: action.hideSpinner !== true,
                error: {}
            });
        case FETCH_USERS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                users: action.data,
                sortedUsers: action.data,
                usersMetadata: action.meta
            });
        case FETCH_USERS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });

        case SEND_USERS_CSV_START:
            return Object.assign({}, state, {
                isSendingUsersCsv: true,
                sendUsersCsvError: {}
            });
        case SEND_USERS_CSV_SUCCESS:
            return Object.assign({}, state, {
                isSendingUsersCsv: false
            });
        case SEND_USERS_CSV_FAILURE:
            return Object.assign({}, state, {
                isSendingUsersCsv: false,
                sendUsersCsvError: action.error
            });

        case SEND_PASSWORD_RESET_START:
            return Object.assign({}, state, {
                isSendingPasswordReset: true
            });
        case SEND_PASSWORD_RESET_SUCCESS:
            return Object.assign({}, state, {
                isSendingPasswordReset: false
            });
        case SEND_PASSWORD_RESET_FAILURE:
            return Object.assign({}, state, {
                isSendingPasswordReset: false
            });

        case SET_USERS:
            return Object.assign({}, state, {
                users: action.data
            });
        case SET_SORTED_USERS:
            return Object.assign({}, state, {
                sortedUsers: action.data
            });
        default:
            return state;
    }
}

export default usersReducer;



// WEBPACK FOOTER //
// ./src/containers/UsersPage/store/reducers.js